export const domRectToSelectionRectangle = (rectangle, region) => {
    const regionDomRect = region.getBoundingClientRect();
    const regionId = region.getAttribute('data-region-selector-id');
    return Object.assign({ top: rectangle.y - regionDomRect.y, left: rectangle.x - regionDomRect.x, width: rectangle.width, height: rectangle.height }, (regionId ? { regionId } : {}));
};
//# sourceMappingURL=TextSelection.js.map